import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_TRAGOP } from "actions/TraGop/actionTypes";
import { getListTraGopSuccess, getListTraGopFailure } from "actions/TraGop";
import TraGopApi from "service/traGopApi";
import { pushNotification } from "utils/notifications";

function* getListTraGop(action) {
  try {
    const response = yield call(TraGopApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListTraGopSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListTraGopFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListTraGopFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_TRAGOP, getListTraGop);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
